























































































































































import { Component, Vue, Prop } from 'vue-property-decorator';

import Table from '@/components/molecules/Table/Table.vue';
import TableCell from '@/components/molecules/TableCell/TableCell.vue';
import TableHeader from '@/components/molecules/TableHeader/TableHeader.vue';
import TableRow from '@/components/molecules/TableRow/TableRow.vue';
import TableCard from '@/componentsV2/molecules/TableCard/TableCard.vue';
import EmptyStateTable from '@/componentsV2/molecules/EmptyStateTable/EmptyStateTable.vue';
import StatusBadge from '@/componentsV2/atoms/StatusBadge/StatusBadge.vue';
import DropDownCardMenu from '@/componentsV2/molecules/DropDownCardMenu/DropDownCardMenu.vue';

import {
  EPaymentStatusTransaction,
  EREturnPolicy,
  IPerformanceTransaction,
  LoyaltyStatus
} from '@/models/performance';
import { IDropDownCardMenu } from '@/models/dropdownCardMenu';

import { IPaginationTableHeader } from '@/utils/PaginationUtils';
import DateUtils from '@/utils/DateUtils';
import { formatMoney } from '@/utils/moneyFormarter';
import Clock from '@/components/icons/ClockSolid.vue';
import { upperCaseFirstLetter } from '@/utils/string';
import { Business } from '@/store/modules/businessTypes';
import { ECoinStatus } from '@/models/transaction';
import PerformanceCustomerCenterService from '@/api/PerformanceCustomerCenterService';
import HTTPStatus from '@/constants/httpStatus';

const WAITING_FOR_STATE_MACHINE = 2500;

enum EInsight {
  DETAIL = 'detail',
  CANCEL_COINS = 'cancel-coins',
  RELEASE_COINS = 'release-coins'
}

@Component({
  components: {
    Table,
    TableCell,
    TableHeader,
    TableRow,
    StatusBadge,
    TableCard,
    EmptyStateTable,
    DropDownCardMenu,
    Clock
  }
})
export default class TransactionsList extends Vue {
  @Prop() headers!: Record<string, IPaginationTableHeader>;
  @Prop() transactions!: IPerformanceTransaction[];
  @Prop() loading?: boolean;

  service: PerformanceCustomerCenterService = new PerformanceCustomerCenterService();

  DateUtils = DateUtils;
  formatMoney = formatMoney;
  upperCaseFirstLetter = upperCaseFirstLetter;

  get isMobileDevice() {
    return this.$mobileCheck();
  }

  get business() {
    return this.$store.getters['business/getBusinessState'] as Business;
  }

  get hasEnabledRefundPolicy() {
    return !!this.business.hadRefund;
  }

  handleContextMenuItemClick(
    action: IDropDownCardMenu,
    transaction: IPerformanceTransaction
  ) {
    const mapper: Record<string, () => void> = {
      [EInsight.DETAIL]: () => this.detail(transaction),
      [EInsight.CANCEL_COINS]: () =>
        this.showDialogCancelTransaction(transaction),
      [EInsight.RELEASE_COINS]: () => this.showDialogConfirmPayment(transaction)
    };

    mapper[action.trigger]();
  }

  contextMenuOptions(
    transaction: IPerformanceTransaction
  ): IDropDownCardMenu[] {
    const buttons = [
      {
        label: 'Detail',
        trigger: EInsight.DETAIL,
        key: EInsight.DETAIL
      }
    ];

    const isBtnConfirmPaymentEnabled = (): boolean => {
      if (transaction.coinsRefundAmount >= transaction.coinsAmount) {
        return false;
      }

      return transaction.coinsStatus === ECoinStatus.PENDING;
    };

    const isBtnCancelTransactionEnabled = (): boolean => {
      if (transaction.coinsStatus === ECoinStatus.ACTIVE) {
        return false;
      }

      if (transaction.coinsRefundAmount >= transaction.coinsAmount) {
        return false;
      }

      const diffDays = this.diffDaysToExpireRefundPolicy(transaction);

      return (
        (transaction.coinsStatus === ECoinStatus.READY && diffDays > 0) ||
        transaction.coinsStatus === ECoinStatus.PENDING
      );
    };

    if (isBtnConfirmPaymentEnabled()) {
      buttons.push({
        label: 'Confirm Payment',
        trigger: EInsight.RELEASE_COINS,
        key: EInsight.RELEASE_COINS
      });
    }

    if (isBtnCancelTransactionEnabled()) {
      buttons.push({
        label: 'Cancel coins',
        trigger: EInsight.CANCEL_COINS,
        key: EInsight.CANCEL_COINS
      });
    }

    return buttons;
  }

  getClassBadgePaymentStatus(status: EPaymentStatusTransaction): string {
    switch (status) {
      case EPaymentStatusTransaction.CONFIRMED:
        return 'green';
      case EPaymentStatusTransaction.PROCESSING:
        return 'orange';
      case EPaymentStatusTransaction.OVERDUE:
        return 'red';
      case EPaymentStatusTransaction.REFUNDED:
      case EPaymentStatusTransaction.REFUNDED_PARTIALLY:
        return 'blue';
      default:
        return 'none';
    }
  }

  getClassBadgeReturnPolicy(status: EREturnPolicy): string {
    switch (status) {
      case EREturnPolicy.COMPLETED:
        return 'green';
      case EREturnPolicy.PENDING:
        return 'orange';
      default:
        return 'none';
    }
  }

  getClassBadgeLayoutStatus(status: LoyaltyStatus): string {
    switch (status) {
      case LoyaltyStatus.COMPLETED:
        return 'green';
      case LoyaltyStatus.PENDING:
        return 'orange';
      case LoyaltyStatus.CANCELED:
        return 'red';
      default:
        return 'none';
    }
  }

  diffDaysToExpireRefundPolicy(transaction: IPerformanceTransaction) {
    const now = DateUtils.formattedDate({
      date: new Date(),
      applyTimezone: true
    });

    const refundPolicyDate = DateUtils.formattedDate({
      date: transaction.refundableUntil,
      applyTimezone: true
    });

    return DateUtils.getDifferenceDays(refundPolicyDate, now) * -1;
  }

  formatReturnPolicy(transaction: IPerformanceTransaction) {
    if (transaction.returnPolicy === EREturnPolicy.COMPLETED) {
      return transaction.returnPolicy;
    }

    const now = DateUtils.formattedDate({
      date: new Date(),
      applyTimezone: true
    });

    const refundPolicyDate = DateUtils.formattedDate({
      date: transaction.refundableUntil,
      applyTimezone: true
    });

    const diffDays = DateUtils.getDifferenceDays(refundPolicyDate, now) * -1;

    return `${diffDays} day${diffDays > 1 ? 's' : ''} left `;
  }
  detail(transaction: IPerformanceTransaction) {
    this.$emit('item-click', transaction);
    this.$router.push(`/performance/transactions-center/${transaction.id}`);
  }

  getClassColumnTable(value: IPaginationTableHeader) {
    return value.label.split(' ').join('-');
  }

  async showDialogConfirmPayment(transaction: IPerformanceTransaction) {
    const responseDialog = await this.$showConfirmDialog({
      title: 'Are you sure you want to confirme this Payment?',
      description:
        'The purchase has not been confirmed and may be canceled until the refund policy configured',
      cancelButtonText: 'Cancel',
      confirmButtonText: 'Confirm',
      align: 'left'
    });

    if (responseDialog !== 'confirm') return;

    const response = await this.service.confirmPayment(transaction.id);

    if (!this.hasErrorOnRequest(response)) {
      this.$notification('Payment confirmed!');
    }

    setTimeout(() => {
      this.updateTransactionOnTable(transaction);
    }, WAITING_FOR_STATE_MACHINE);
  }

  async showDialogCancelTransaction(transaction: IPerformanceTransaction) {
    const responseDialog = await this.$showConfirmDialog({
      title: 'Are you sure you want to cancel this Transaction?',
      description: `This transaction will be cancelled and the consumer wont receive the coins. You can't roll back this action!`,
      cancelButtonText: 'Cancel',
      confirmButtonText: 'Confirm',
      align: 'left'
    });

    if (responseDialog !== 'confirm') return;

    const response = await this.service.cancelTransaction(transaction.id);

    if (!this.hasErrorOnRequest(response)) {
      this.$notification('Transaction canceled!');
    }

    setTimeout(() => {
      this.updateTransactionOnTable(transaction);
    }, WAITING_FOR_STATE_MACHINE);
  }

  hasErrorOnRequest(resp: any): boolean {
    const status = resp.status;
    return status !== HTTPStatus.OK && status !== HTTPStatus.CREATED;
  }

  async updateTransactionOnTable(transaction: IPerformanceTransaction) {
    const { data } = await this.service.detailTransaction(transaction.id);

    this.$emit('updateTransaction', data.transaction);
  }
}
